export default function() {
    if (document.querySelector('.domain-search-form')) {
        const main = document.querySelector('main.vue-page.domain-search-form');
        const footer = document.querySelector('footer');

        if (main) {
            footer.classList.add('has-cart-footer');
        }
    }
}